module.exports = __webpack_public_path__ + "img/bkcode.2c81fe4e.jpg";